$(() => {
  $('tr[data-link]').click(function() {
    location.href = $(this).data('link');
  });
});